import React from 'react';
import { Button, Result } from 'antd';
import { useNavigate } from 'react-router-dom';

const NotFound = () => {
  const navigate = useNavigate();
  return (
    <Result
      status="404"
      title="Không tìm thấy trang"
      subTitle="Đường dẫn có thể đã đổi. Dùng ô “Tìm chức năng” ở góc trên (Ctrl K) hoặc quay về Tổng quan."
      extra={
        <Button type="primary" onClick={() => navigate('/')}>
          Về Tổng quan
        </Button>
      }
    />
  );
};

export default NotFound;
